import { render, staticRenderFns } from "./CustomerChangeNameModal.vue?vue&type=template&id=75dc1b2a&"
import script from "./CustomerChangeNameModal.vue?vue&type=script&lang=js&"
export * from "./CustomerChangeNameModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports